// src/server/api.ts

// 这里配置您的后端服务器地址
// 开发时用 localhost，等您的后端部署到云服务器后，改成类似 'https://api.lesjeuxa.com'
const BASE_URL = 'https://lesjeuxa.com/api';

/**
 * 获取已发布的公告列表
 */
export async function fetchAnnouncements() {
    try {
        const response = await fetch(`${BASE_URL}/announcements`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('获取公告数据失败:', error);
        return []; // 失败时返回空数组，防止前端报错
    }
}

// 以后如果有获取产品信息、提交用户反馈等接口，都可以在这里继续添加
// export async function submitFeedback(data) { ... }
